import { render, staticRenderFns } from "./ManageDrug.vue?vue&type=template&id=b86902c2&scoped=true&"
import script from "./ManageDrug.vue?vue&type=script&lang=js&"
export * from "./ManageDrug.vue?vue&type=script&lang=js&"
import style0 from "./ManageDrug.vue?vue&type=style&index=0&id=b86902c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86902c2",
  null
  
)

export default component.exports